// Mock data for CodifyTech website
import { Mail, Phone, MapPin, Clock } from "lucide-react";

export const companyInfo = {
  name: "Codify Tech",
  tagline: "Transforming ideas into high-performance web and mobile applications using FlutterFlow, React Native, AI automation, cloud technologies, and modern design.",
  description: "We design and build high-quality digital products across modern web, mobile, backend, cloud, and AI technologies—delivering scalable solutions using the right tech for your business.",
  phone: "+91 7558746109",
  address: "Ashar IT Park, Mulund, Mumbai",
  email: "team@codiytech.co.in",
  contactInfo: [
    {
      title: "Email",
      content: "team@codiytech.co.in",
      link: "mailto:team@codiytech.co.in",
      icon: Mail,
    },
    {
      title: "Phone",
      content: "+91 7558746109",
      link: "tel:+917558746109",
      icon: Phone,
    },
    {
      title: "Location",
      content: "Ashar IT Park, Mulund, Mumbai",
      icon: MapPin,
    },
    {
      title: "Working Hours",
      content: "Mon – Fri, 9AM – 6PM",
      icon: Clock,
    },
  ],
};

export const services = [
  {
    id: 1,
    title: "Custom FlutterFlow Development",
    description: "Build tailored mobile and web applications using FlutterFlow that perfectly match your business requirements and deliver exceptional user experiences.",
    features: ["iOS & Android Apps", "Web Applications", "Cross-Platform Solutions", "Custom Code Integration"]
  },
  {
    id: 2,
    title: "AI Automation & Workflows",
    description: "Transform your business operations with powerful AI-driven automation solutions that streamline workflows, reduce manual effort, and enhance productivity across your organization.",
    features: ["AI Chatbots & Assistants", "Process Automation", "Data Insights & Optimizatione"]
  },
  {
    id: 3,
    title: "React Native App Development",
    description: "Create high-performance cross-platform mobile apps using React Native, delivering native-like experiences with faster development cycles and reduced costs.",
    features: ["iOS & Android Apps", "Cross-Platform Development", "Scalable Architecture"]
  },
  {
    id: 4,
    title: "Swift App Development",
    description: "Build robust, secure, and beautifully-designed native iOS applications using Swift — optimized for performance and seamless user experiences on Apple devices.",
    features: ["Native iOS Development", "App Store Deployment", "Performance Optimization"]
  },
  {
    id: 5,
    title: "UI/UX Design",
    description: "Create stunning, user-friendly interfaces that provide exceptional user experiences and drive engagement with modern design principles.",
    features: ["User Research", "Wireframing", "Prototyping", "Design Systems"]
  },
  {
    id: 6,
    title: "Maintenance & Support",
    description: "Comprehensive maintenance and support services to keep your applications running smoothly with updates, bug fixes, and performance optimization.",
    features: ["Bug Fixes", "Feature Updates", "Performance Optimization", "Technical Support"]
  }
];

export const portfolio = [
  {  id: 13,
    title: "Bombay Shaving Company",
    category: "Mobile & Web App",
    description: "Developed by Codify Tech, the Bombay Shaving Company e-commerce platform enables seamless online sales of shaving and beauty products.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Bombay%20Shaving.png",
    applink: "https://www.bombayshavingcompany.com/?srsltid=AfmBOor59q5McOgXZFnhsTUSOdg9S0AH8oB8Wgxp5CmMdouZ8aDEqFRL"
  },
  {
    id: 15,
    title: "Panama City Songwriters Fest",
    category: "Mobile App",
    description: "Developed by Codify Tech, this app supports the Panama City Songwriter Festival by showcasing events, artists, and venues in Downtown Panama City, Florida.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Panama%20City.png",
    applink: "https://apps.apple.com/us/app/panama-city-songwriters-fest/id6470503315"
  },
  {
    id: 2,
    title: "Be Light App",
    category: "Mobile App",
    description: "BE LIGHT combines neuroscience-based light and sound frequencies with meditation and breathwork to harmonise the brain and nervous system.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Firestore"],
    client: "GreenTech Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/be%20light.png",
    applink: "https://apps.apple.com/in/app/be-light-calm-in-minutes/id1596583711"
  },  
  {
    id: 14,
    title: "SheIs",
    category: "Mobile & Web App",
    description: "Developed by Codify Tech, the SheIS Sports Network app connects users with the latest news and events in women’s sports.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/SheIs.jpg",
    applink: "https://sheissportsapp.com/"
  },
  {
    id: 1,
    title: "Empty Vase App",
    category: "Mobile & Web App",
    description: "Empty Vase, Los Angeles Luxury Florist. Buy and send flowers and access unique discounts exclusively through the app. Same-day pick-up and delivery.",
    technologies: ["FlutterFlow", "Shopify", "FCM"],
    client: "Advertising & Marketing Co",
    timeline: "4 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Empty%20Vase%20Florist%20logo%20design.jpg",
    applink: "https://apps.apple.com/in/app/empty-vase/id6462795052"
  },
  {
    id: 3,
    title: "Jem Social",
    category: "Mobile & Web App",
    description: "Jem Social helps you discover top influencers, manage campaigns, and track real results from one powerful platform.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Jem%20Social.jpg",
    applink: "https://apps.apple.com/in/app/jem-turn-content-into-cash/id6443547790"
  },
  {
    id: 4,
    title: "BYOU Partners",
    category: "Mobile & Web App",
    description: "This app was designed and developed by Codify Tech to help users discover wellbeing professionals in the personal services and mental health industry.",
    technologies: ["FlutterFlow", "Firebase", "Stripe API", "Cloud Functions"],
    client: "RetailMart",
    timeline: "5 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Byou%20Partners.jpg",
    applink: "https://apps.apple.com/in/app/byou-partners/id1481335206"
  },
  {
    id: 5,
    title: "Yoga Norge",
    category: "Mobile App",
    description: "Yoga Norge helps you find balance, build strength, and improve flexibility—wherever you are in your yoga journey.",
    technologies: ["FlutterFlow", "Firebase Auth", "Cloud Storage"],
    client: "WellnessHub Inc",
    timeline: "4 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Yoga%20Norge.jpg",
    applink: "https://apps.apple.com/tw/app/yoga-norge/id6469766732?l=en-GB"
  },

  {
    id: 6,
    title: "BYOU Wellbeing",
    category: "Mobile App",
    description: "BYOU The all in one app for Beauty, Health & Mental Wellbeing",
    technologies: ["FlutterFlow", "Firebase", "Cloud Messaging"],
    client: "EduTech Innovations",
    timeline: "4 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Byou%20Wellbeing.jpg",
    applink: "https://apps.apple.com/bw/app/byou-wellbeing/id1481335241"
  },
 

  {
    id: 7,
    title: "Sparksfly",
    category: "Mobile App",
    description: "Designed to make online dating feel more real and traditional with more calling and video chatting and less texting.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Sparksfly.jpg",
    applink: "https://apps.apple.com/in/app/sparksfly-meet-date-love/id1642910676"
  },
  {
    id: 8,
    title: "Kappa Loop",
    category: "Mobile App",
    description: "Kappa Loop is the official mobile app for Kappa Alpha Psi Fraternity, Inc., connecting brothers across all chapters, provinces, and the Grand Chapter.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Kappa%20Loop.jpg",
    applink: "https://apps.apple.com/us/app/kappa-loop/id6720763562"
  },
  {
    id: 9,
    title: "Shae: Virtual Health Assistant",
    category: "Mobile App",
    description: "Shae helps you stay healthy, full of life and feeling your best by harnessing the power of your epigenetics.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Shae.jpg",
    applink: "https://apps.apple.com/au/app/shae-virtual-health-assistant/id1148524178"
  },
  {
    id: 10,
    title: "Notespaedia",
    category: "Mobile & Web App",
    description: "Notespaedia is a smart note-sharing platform that helps students easily access, organize, and study academic notes in one place.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Notespaedia.jpg",
    applink: "https://play.google.com/store/apps/details?id=com.notespaediaapp&hl=en_IN"
  },

  {
    id: 11,
    title: "Plantation Baptist Church",
    category: "Mobile App",
    description: "Developed by Codify Tech, this app enables users to connect with and watch live streams from Plantation Baptist Church—a diverse and welcoming community of believers.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Plantation%20Baptist.jpg",
    applink: "https://play.google.com/store/apps/details?id=com.goodbarber.plantation"
  },

  {
    id: 12,
    title: "Edustaff",
    category: "Mobile App",
    description: "Developed by Codify Tech, the Edustaff Candidates app simplifies the job application process for teachers and professors.",
    technologies: ["FlutterFlow", "Firebase", "Cloud Functions"],
    client: "ProTeam Solutions",
    timeline: "3 months",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/EduStaff.jpg",
    applink: "https://play.google.com/store/apps/details?id=com.mycompany.candidate"
  },

];

export const team = [
  {
    id: 1,
    name: "Aditya giri",
    role: "CEO & Founder",
    bio: "10+ years in mobile development with 5 years specializing in FlutterFlow.",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/CEO%20Image.jpg"
  },
  {
    id: 2,
    name: "Pratit Todkar",
    role: "CTO & Co-Founder",
    bio: "Award-winning designer focused on creating intuitive and beautiful user experiences.",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/Pratit%20Official.jpg"
  },
  {
    id: 3,
    name: "Ashutosh Giri",
    role: "COO & Co-Founder",
    bio: "Full-stack developer passionate about building scalable FlutterFlow applications.",
    image: "https://raw.githubusercontent.com/wwwjonnyfaxan786-hash/portfolio-assets/main/COO%20Image.jpg"
  },
 
];

export const testimonials = [
  {
    id: 1,
    name: "Danique Motzheim",
    company: "BYOU Inc",
    role: "CEO",
    text: "The team has managed the project well and delivered items on time. Their timing and cost are also great, and their resources have shown a thorough understanding of the client’s needs while giving helpful feedback."
  },
  {
    id: 2,
    name: "Dr. Mohammed Irshad",
    company: "Notespaedia",
    role: "CEO",
    text: "I was pleased with the results of their engagement with Codify. They commended the team for their excellent work ethic, knowledge, and on-time delivery. Overall, the project was a success."
  },
  {
    id: 3,
    name: "Godson Inikori",
    company: "Quickgredients Inc",
    role: "CEO",
    text: "I was satisfied with the work from Codify, and the team was able to successfully implement various features. The service provider was prompt in their approach to communication and delivered everything on time. I was impressed with Codify's ability to supply valuable suggestions." 


  }
];

export const stats = [
  { label: "Projects Completed", value: "150+" },
  { label: "Happy Clients", value: "80+" },
  { label: "Years Experience", value: "6+" },
  { label: "Team Members", value: "25+" }
];
